import { apiFetch } from "./client";
import type {
  InteractionCreatePayload,
  InteractionCreateResponse,
  InteractionReportPayload,
  InteractionReportResponse,
  InteractionNotOccurredPayload,
  InteractionNotOccurredResponse,
  InteractionReschedulePayload,
  InteractionRescheduleResponse,
  TodayMeetingsQuery,
  TodayMeetingsResponse,
} from "./types";

export function createInteraction(
  body: InteractionCreatePayload,
): Promise<InteractionCreateResponse> {
  return apiFetch<InteractionCreateResponse>("/Custom/frontend/interactions", {
    method: "POST",
    body,
  });
}

export function reportInteraction(
  id: string,
  body: InteractionReportPayload,
): Promise<InteractionReportResponse> {
  return apiFetch<InteractionReportResponse>(
    `/Custom/frontend/interactions/${encodeURIComponent(id)}/report`,
    { method: "POST", body },
  );
}

export function markNotOccurred(
  id: string,
  body: InteractionNotOccurredPayload,
): Promise<InteractionNotOccurredResponse> {
  return apiFetch<InteractionNotOccurredResponse>(
    `/Custom/frontend/interactions/${encodeURIComponent(id)}/not-occurred`,
    { method: "POST", body },
  );
}

export function rescheduleInteraction(
  id: string,
  body: InteractionReschedulePayload,
): Promise<InteractionRescheduleResponse> {
  return apiFetch<InteractionRescheduleResponse>(
    `/Custom/frontend/interactions/${encodeURIComponent(id)}/reschedule`,
    { method: "POST", body },
  );
}

/** D-055 S6 — MeetingDetailDrawer (екран 3): GET однієї meeting-interaction. */
export interface InteractionDetail {
  id: string;
  summary: string;
  type: string;
  meetingType: string | null;
  meetingStatus: string;
  occurredAt: string | null;
  durationMinutes: number | null;
  goal: string | null;
  expectedResult: string | null;
  contactId: string | null;
  contactName: string | null;
  accountName: string | null;
  targetHoldingId: string | null;
  /** D-134 — лід-зустріч (target = prospect-Account, holding=null). */
  isProspect?: boolean;
  /** D-134 — лід-поля (контакт=поля, НЕ Contact-сутність). null коли не лід. */
  prospect?: {
    accountId: string;
    name: string;
    contactPerson: string | null;
    phone: string | null;
    email: string | null;
    city: string | null;
    comment: string | null;
  } | null;
  assignedUserName: string | null;
  reportSubmitted: boolean;
  reportSubmittedAt: string | null;
  reportSlaDueAt: string | null;
  reportOverdueSince: string | null;
  /** D-151 S2 (P73) — CAS-токен для всіх write-дій drawer-а. */
  interactionRevision: number;
  /** D-151 S2 (C8) — незмінна атрибуція подання. */
  reportSubmissionMode: "own" | "supervisor_on_behalf" | "admin_override" | null;
  reportSubmittedByName: string | null;
  reportSubmittedForName: string | null;
  reportOnBehalfReason: string | null;
  /** D-151 S2 (§3.8) — server-derived контекст confirm-кроку (4 стани). */
  onBehalfContext: {
    overdue: boolean;
    overdueSince: string | null;
    slaDueAt: string | null;
    occurredConfirmRequired: boolean;
    draft: {
      hasContent: boolean;
      fresh: boolean;
      savedAt: string | null;
      ageHours: number | null;
      savedByName: string | null;
    };
    expectedAssignedUserId: string;
  } | null;
  reviewStatus: "not_required" | "pending_review" | "accepted" | "returned";
  reviewComment: string | null;
  report: {
    text: string;
    outcome: string | null;
    riskMarkers: string[];
    risk: boolean;
    nextActionRequired: "yes" | "no" | "unknown" | null;
    nextActionReason: string | null;
  } | null;
  allowedActions: {
    canMarkOccurred: boolean;
    canFillReport: boolean;
    canReschedule: boolean;
    canCancel: boolean;
    /** D-151 S2 — on-behalf (server-derived; FE нічого не інферить). */
    canFillReportOnBehalf: boolean;
    canFillReportOnBehalfBlockedByFreshDraft: boolean;
    canMarkOccurredOnBehalf: boolean;
  };
}

export function fetchInteractionDetail(
  id: string,
  signal?: AbortSignal,
): Promise<InteractionDetail> {
  return apiFetch<InteractionDetail>(
    `/Custom/frontend/interactions/${encodeURIComponent(id)}`,
    { method: "GET", signal },
  );
}

export function fetchTodayMeetings(
  q: TodayMeetingsQuery = {},
  signal?: AbortSignal,
): Promise<TodayMeetingsResponse> {
  return apiFetch<TodayMeetingsResponse>("/Custom/frontend/today/meetings", {
    query: {
      date: q.date,
      includeOverdue: q.includeOverdue,
      includeCompleted: q.includeCompleted,
    },
    signal,
  });
}
